var React = require('react');

function ClientBackground (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_751","data-name":"Path 751","d":"M221.639,1.95C177.45-7.176,149.372,18.931,64,14.579c-98-5-74.3,66.365,9.367,97.623,89.993,33.622,178.452,34.818,193.2-39.224C266.483,72.957,280.345,14.074,221.639,1.95Z","transform":"translate(284.012 132.948) rotate(172)","fill":"#00ac49"}));
}

ClientBackground.defaultProps = {"width":"284.012","height":"170.237","viewBox":"0 0 284.012 170.237"};

module.exports = ClientBackground;

ClientBackground.default = ClientBackground;
